class NSSFAQsFilter extends HTMLElement {

  constructor() {
    super();

    this.heights = {
      bar: getComputedStyle(document.documentElement).getPropertyValue('--nss-bar-height').replace(`px`, ``),
      header: getComputedStyle(document.documentElement).getPropertyValue('--nss-header-height').replace(`px`, ``),
    }

    this.firstOpenByDefault = this.getAttribute(`nss-first-open-by-default`);

    this.filterEl;
    this.threshold;

    this.debug = false;
  }

  connectedCallback() {
    if (this.debug) console.log("[NSS][FAQs Filter] Connected.");

    this.checkWidth();
    const debounceResize = this.debounce(this.checkWidth.bind(this), 100);
    window.addEventListener(`resize`, debounceResize);

    const filterEl = this.querySelector('.nss-faqs-filter__faqs-category-filter-wrapper');
    if (filterEl) {
      this.filterEl = filterEl;
      this.threshold = window.pageYOffset + this.filterEl.getBoundingClientRect().top - this.heights.bar - this.heights.header
      const debounceScroll = this.debounce(this.filterStick.bind(this), 5);
      window.addEventListener(`scroll`, debounceScroll);
    }

    this.addEventListener(`click`, this.processClick.bind(this));
  }

  checkWidth() {
    /**
     * Magic numbers that need replaced:
     *   10 - This is the margin to the right of each li
     *   1092 - This is the minimum width before scrolling is necessary
     */
    const categoriesEl = this.querySelector(`.nss-faqs-filter__faqs-categories`);
    if (categoriesEl) {
      const categoryEls = this.querySelectorAll(`.nss-faqs-filter__faqs-categories li`);
      let totalWidth = 0;
      categoryEls.forEach((categoryEl) => {
        totalWidth += categoryEl.getBoundingClientRect().width + 10;
      });
      if (this.debug) console.log(`[NSS][FAQs Filter] totalWidth:`, totalWidth);
      let vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
      if (vw >= 1092 && totalWidth < 1092) {
        categoriesEl.classList.add(`nss-no-scroll`);
      } else {
        categoriesEl.classList.remove(`nss-no-scroll`);
      }
    }
  }

  filterStick() {
    let currentScroll = window.scrollY;
    if (currentScroll >= this.threshold) {
      this.filterEl.classList.add('nss-stick');
    } else {
      this.filterEl.classList.remove('nss-stick');
    }
  }

  processClick(e) {
    if (this.debug) console.log(`[NSS][FAQs Filter] Clicked:`, e.target);

    this.closeFilterDropdown();

    if (e.target.hasAttribute(`nss-faqs-filter-button`)) {
      const dropdownEl = this.querySelector(`[nss-faqs-filter-dropdown]`);
      dropdownEl.classList.add(`nss-active`);
    }

    if (e.target.hasAttribute(`nss-faqs-category`)) {
      this.closeAllFAQs();
      this.closeAllCategories();
      const handle = e.target.getAttribute(`nss-faqs-category`);
      if (handle === "all") {
        this.openCategory(handle);
        this.openAllCategoryItems();
        this.openFirstFAQ();
      } else {
        this.openCategory(handle);
        this.openCategoryItems(handle);
      }
      const text = e.target.textContent;
      this.updateCategoryText(text);
    }

    if (e.target.hasAttribute(`nss-faq-item`)) {
      if (e.target.classList.contains(`nss-active`)) {
        e.target.classList.remove(`nss-active`);
      } else {
        this.closeAllFAQs();
        e.target.classList.add(`nss-active`);
      }
    }
  }

  closeFilterDropdown() {
    const dropdownEl = this.querySelector(`[nss-faqs-filter-dropdown]`);
    if (dropdownEl) {
      dropdownEl.classList.remove(`nss-active`);
    }
  }

  openFirstFAQ(handle) {
    if (this.firstOpenByDefault === "true") {
      if (handle) {
        const faqEl = this.querySelectorAll(`[nss-faqs-items="${handle}"] button`)[0];
        faqEl.classList.add(`nss-active`);
      } else {
        const faqEl = this.querySelectorAll(`[nss-faqs-items].nss-active button`)[0];
        faqEl.classList.add(`nss-active`);
      }
    }
  }

  closeAllFAQs() {
    const faqEls = this.querySelectorAll(`[nss-faq-item].nss-active`);
    faqEls.forEach((faqEl) => {
      faqEl.classList.remove(`nss-active`);
    });
  }

  openCategory(handle) {
    const categoryEls = this.querySelectorAll(`[nss-faqs-category="${handle}"]`);
    categoryEls.forEach((categoryEl) => {
      categoryEl.classList.add(`nss-active`);
    });
  }

  openCategoryItems(handle) {
    const itemsEl = this.querySelector(`[nss-faqs-items="${handle}"]`);
    itemsEl.classList.add(`nss-active`);
    this.openFirstFAQ(handle);
  }

  closeAllCategories() {
    const activeCategoryEls = this.querySelectorAll(`[nss-faqs-category].nss-active`);
    activeCategoryEls.forEach((activeCategoryEl) => {
      activeCategoryEl.classList.remove(`nss-active`);
    });
    const activeItemsEls = this.querySelectorAll(`[nss-faqs-items].nss-active`);
    activeItemsEls.forEach((activeItemsEl) => {
      activeItemsEl.classList.remove(`nss-active`);
    });
  }

  openAllCategoryItems() {
    const itemsEls = this.querySelectorAll(`[nss-faqs-items]`);
    itemsEls.forEach((itemsEl) => {
      itemsEl.classList.add(`nss-active`);
    });
  }

  updateCategoryText(text) {
    const textEls = this.querySelectorAll(`[nss-active-category]`);
    textEls.forEach((textEl) => {
      textEl.innerHTML = text;
    });
  }
  
  debounce(func, delay) {
    let timerId;
  
    return function (...args) {
      clearTimeout(timerId);
      timerId = setTimeout(() => {
        func.apply(this, args);
      }, delay);
    };
  }
}

let elementName = `nss-faqs-filter`;
if (typeof customElements.get(elementName) === `undefined`) {
  customElements.define(elementName, NSSFAQsFilter);
} else {
  console.warn(`[NSS] Element '${elementName}' already defined.`)
}